// src/pages/admin/dashboard/components/DashboardGrowthCharts.js
import React from "react";
import { Row, Col, Card, Badge } from "react-bootstrap";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis
} from "recharts";

const DashboardGrowthCharts = ({ monthlyData, roleCategoryData, COLORS }) => {
  return (
    <Row className="g-4 mb-4">
      {/* AREA CHART */}
      <Col lg={8}>
        <Card className="dashboard-chart-card h-100">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="chart-title">
                Monthly Platform Growth
              </h5>

              <Badge bg="danger">
                2026
              </Badge>
            </div>

            <ResponsiveContainer
              width="100%"
              height={320}
            >
              <AreaChart data={monthlyData}>
                <defs>
                  <linearGradient
                    id="colorRevenue"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="5%"
                      stopColor="#8B0000"
                      stopOpacity={0.8}
                    />

                    <stop
                      offset="95%"
                      stopColor="#8B0000"
                      stopOpacity={0}
                    />
                  </linearGradient>
                </defs>

                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#222"
                />

                <XAxis dataKey="month" />

                <YAxis />

                <Tooltip 
                  cursor={{ fill: 'rgba(255, 255, 255, 0.05)', stroke: 'rgba(255, 255, 255, 0.2)' }} 
                  contentStyle={{ backgroundColor: '#0f172a', borderColor: '#1e293b', borderRadius: '8px', color: '#fff' }} 
                />

                <Area
                  type="monotone"
                  dataKey="revenue"
                  stroke="#ff1744"
                  fillOpacity={1}
                  fill="url(#colorRevenue)"
                />
              </AreaChart>
            </ResponsiveContainer>
          </Card.Body>
        </Card>
      </Col>

      {/* PIE CHART */}
      <Col lg={4}>
        <Card className="dashboard-chart-card h-100">
          <Card.Body>
            <h5 className="chart-title mb-4">
              Project Categories
            </h5>

            <ResponsiveContainer
              width="100%"
              height={320}
            >
              <PieChart>
                <Pie
                  data={roleCategoryData}
                  cx="50%"
                  cy="50%"
                  outerRadius={110}
                  fill="#8884d8"
                  dataKey="value"
                  label
                >
                  {roleCategoryData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>

                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default DashboardGrowthCharts;
